import type { HTMLAttributes, ReactNode } from "react";
import { CircleCheck, CircleX, Info, TriangleAlert } from "lucide-react";

export type AlertVariant = "info" | "warning" | "success" | "error";

export type AlertProps = Omit<HTMLAttributes<HTMLDivElement>, "title"> & {
  variant?: AlertVariant;
  title?: ReactNode;
  icon?: ReactNode | false;
};

const defaultIcons: Record<AlertVariant, ReactNode> = {
  info: <Info aria-hidden="true" />,
  warning: <TriangleAlert aria-hidden="true" />,
  success: <CircleCheck aria-hidden="true" />,
  error: <CircleX aria-hidden="true" />,
};

export default function Alert({
  variant = "info",
  title,
  icon,
  children,
  className,
  role,
  ...props
}: AlertProps) {
  const classes = ["foundation-alert", `variant-${variant}`, className].filter(Boolean).join(" ");

  return (
    <div className={classes} role={role ?? (variant === "error" ? "alert" : "status")} {...props}>
      {icon !== false ? <span className="icon">{icon ?? defaultIcons[variant]}</span> : null}
      <div className="content">
        {title ? <div className="title">{title}</div> : null}
        <div className="message">{children}</div>
      </div>
    </div>
  );
}
